import Icon from '@ant-design/icons';
// import Icon from "antd/es/icon";

const HeartSvg = () => (
  <svg
    width='1em'
    height='1em'
    fill='currentColor'
    viewBox='0 0 1024 1024'
  >
    <path d='M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z' />
  </svg>
);

const PandaSvg = () => (
  <svg
    viewBox='0 0 1024 1024'
    width='1em'
    height='1em'
    fill='currentColor'
  >
    <path
      d='M99.096 315.634s-82.58-64.032-82.58-132.13c0-66.064 33.032-165.162 148.646-148.646 83.37 11.91 99.096 165.162 99.096 165.162l-165.162 115.614zM924.906 315.634s82.58-64.032 82.58-132.13c0-66.064-33.032-165.162-148.646-148.646-83.37 11.91-99.096 165.162-99.096 165.162l165.162 115.614z'
      fill='#6B676E'
      p-id='1143'
    />
    <path
      d='M1024 561.548c0 264.526-229.23 429.42-512.002 429.42S0 826.076 0 561.548 283.96 66.064 512.002 66.064 1024 297.022 1024 561.548z'
      fill='#FFEBD2'
      p-id='1144'
    />
    <path
      d='M330.324 842.126c0 82.096 81.34 148.646 181.678 148.646s181.678-66.55 181.678-148.646H330.324z'
      fill='#E9D7C3'
      p-id='1145'
    />
    <path
      d='M644.13 611.098C594.582 528.516 561.55 512 512.002 512c-49.548 0-82.58 16.516-132.13 99.096-42.488 70.814-78.73 211.264-49.548 247.742 66.064 82.58 165.162 33.032 181.678 33.032 16.516 0 115.614 49.548 181.678-33.032 29.18-36.476-7.064-176.93-49.55-247.74z'
      fill='#FFFFFF'
      p-id='1146'
    />
    <path
      d='M611.098 495.484c0-45.608 36.974-82.58 82.58-82.58 49.548 0 198.194 99.098 198.194 165.162s-79.934 144.904-148.646 99.096c-49.548-33.032-132.128-148.646-132.128-181.678zM412.904 495.484c0-45.608-36.974-82.58-82.58-82.58-49.548 0-198.194 99.098-198.194 165.162s79.934 144.904 148.646 99.096c49.548-33.032 132.128-148.646 132.128-181.678z'
      fill='#6B676E'
      p-id='1147'
    />
    <path
      d='M512.002 726.622c-30.06 0-115.614 5.668-115.614 33.032 0 49.638 105.484 85.24 115.614 82.58 10.128 2.66 115.614-32.944 115.614-82.58-0.002-27.366-85.556-33.032-115.614-33.032z'
      fill='#464655'
      p-id='1148'
    />
    <path
      d='M330.324 495.484m-33.032 0a33.032 33.032 0 1 0 66.064 0 33.032 33.032 0 1 0-66.064 0Z'
      fill='#464655'
      p-id='1149'
    />
    <path
      d='M693.678 495.484m-33.032 0a33.032 33.032 0 1 0 66.064 0 33.032 33.032 0 1 0-66.064 0Z'
      fill='#464655'
      p-id='1150'
    />
  </svg>
);

const LockSvg = () => (
  <svg
    width='12'
    height='14'
    viewBox='0 0 8 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.9 3.5H6.53224V2.64286C6.53224 1.46 5.51097 0.5 4.25263 0.5C2.99429 0.5 1.97303 1.46 1.97303 2.64286V3.5H0.605263V9.5H7.9V3.5ZM2.88487 2.64286C2.88487 1.93143 3.4958 1.35714 4.25263 1.35714C5.00946 1.35714 5.62039 1.93143 5.62039 2.64286V3.5H2.88487V2.64286ZM6.98816 8.64286H1.5171V4.35714H6.98816V8.64286ZM4.25263 7.35714C4.75414 7.35714 5.16447 6.97143 5.16447 6.5C5.16447 6.02857 4.75414 5.64286 4.25263 5.64286C3.75112 5.64286 3.34079 6.02857 3.34079 6.5C3.34079 6.97143 3.75112 7.35714 4.25263 7.35714Z'
      fill='#1D1D1D'
    />
  </svg>
);

const LoginImg = () => (
  <svg
    width='209'
    height='184'
    viewBox='0 0 209 184'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      cx='28.7117'
      cy='-9.28834'
      r='28.7117'
      fill='#C37300'
    />
    <circle
      cx='86.135'
      cy='48.135'
      r='28.7117'
      fill='#FA9D1C'
    />
    <circle
      cx='210.712'
      cy='154.712'
      r='28.7117'
      fill='#FA9D1C'
    />
    <circle
      cx='210.552'
      cy='83.865'
      r='28.7117'
      fill='#C37300'
    />
    <path
      d='M157.595 -5.53374C157.595 -20.9977 170.131 -33.5337 185.595 -33.5337H215.018V-4.1104C215.018 11.3536 202.482 23.8896 187.018 23.8896H157.595V-5.53374Z'
      fill='#C37300'
    />
    <path
      d='M0 47.4233C0 31.9593 12.536 19.4233 28 19.4233H57.4233V48.8466C57.4233 64.3106 44.8873 76.8466 29.4233 76.8466H0V47.4233Z'
      fill='#B5B3B4'
    />
    <path
      d='M152.417 110.025C136.953 110.025 124.417 97.4885 124.417 82.0245L124.417 52.6012L153.84 52.6012C169.304 52.6012 181.84 65.1372 181.84 80.6012L181.84 110.025L152.417 110.025Z'
      fill='#B5B3B4'
    />
  </svg>
);
const SellToMasonSvg = () => (
  <svg
    width='100%'
    height='100%'
    viewBox='0 0 26 23'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M25.1902 17.3204C24.2088 15.8866 23.1719 14.4341 22.1906 13.0375L21.8203 12.5161C20.95 11.287 20.1168 10.6539 19.154 10.4863C18.1911 10.3373 17.1913 10.6725 15.9877 11.5477C15.0064 12.274 14.0065 13.0002 13.0066 13.7451L12.3586 14.2292C12.229 14.3223 12.0438 14.3037 11.9512 14.1734L11.5994 13.6892C11.5068 13.5589 11.5439 13.3913 11.655 13.2795C11.7105 13.2423 11.7475 13.205 11.8031 13.1678C12.4141 12.7023 12.9696 12.2553 13.5436 11.7898C14.6731 10.8774 15.2286 9.7973 15.1175 8.71725C15.0064 7.6372 14.2472 6.66887 12.9511 5.97988L11.7846 5.36536C8.69241 3.72667 5.47062 2.0321 2.30438 0.393403C1.97109 0.225809 1.61929 0.169944 1.32303 0.132701C1.21194 0.114079 1.08233 0.0954576 0.989747 0.076836L0.619426 0.00234971C0.471298 -0.0162719 0.304654 0.076836 0.286138 0.24443L0.23059 0.616862C0.212074 0.728591 0.175042 0.840321 0.13801 0.970672C0.0454301 1.30586 -0.0471499 1.69691 0.0269141 2.12521C0.860135 6.31506 1.67484 10.4491 2.50806 14.3968C2.7858 15.7376 3.48941 16.6873 4.50779 17.0597C5.54468 17.4508 6.72971 17.1714 7.84067 16.2962L9.32195 15.1417C9.45156 15.0486 9.63672 15.0672 9.7293 15.1976C9.82188 15.3279 9.89595 15.4396 9.98853 15.5514C11.118 17.1342 12.1364 17.3018 13.7288 16.1659C14.2657 15.7934 14.8027 15.4024 15.3211 15.03L15.3582 14.9927C15.5063 15.3465 15.6729 15.719 15.8951 16.0541C17.0246 17.7301 18.2282 19.4433 19.5983 21.3427C20.376 22.4227 21.487 23 22.5794 23C23.2275 23 23.894 22.7952 24.4866 22.3855C26.2085 21.1937 26.4863 19.2012 25.1902 17.3204ZM22.3943 20.6537C22.1906 20.6164 22.0054 20.5047 21.8388 20.2812C20.4871 18.4936 19.191 16.5942 17.9504 14.7506L17.6356 14.2851C17.5986 14.2292 17.5616 14.0244 17.5431 13.8754C17.5245 13.8196 17.5245 13.7451 17.506 13.6892C17.5616 13.6333 17.5986 13.5775 17.6356 13.5216C17.8023 13.3354 18.043 13.0375 18.1726 13.0002C18.5244 12.9257 19.0799 13.0375 19.228 13.1492C19.2465 13.1678 19.265 13.1864 19.265 13.1864C20.5797 14.881 21.9128 16.7618 23.4682 19.1081C23.857 19.704 23.4311 20.1509 23.1534 20.3744C22.8942 20.5978 22.635 20.6909 22.3943 20.6537ZM7.39629 8.8476L6.82229 8.56828C6.61861 8.47517 6.3779 8.62414 6.41494 8.86622L6.47049 9.49936C6.47049 9.57384 6.47049 9.68557 6.47049 9.7973C6.47049 10.1139 6.47049 10.5049 6.67416 10.8587C7.08151 11.5105 7.5259 12.1436 7.97028 12.7395C8.06286 12.8699 8.04435 13.0375 7.91473 13.1306C7.8777 13.1678 7.84067 13.205 7.78512 13.2237C7.21113 13.7078 6.65565 14.1734 6.08165 14.583C5.78539 14.7879 5.50765 14.8624 5.28546 14.7879C5.1003 14.7134 4.95217 14.5086 4.89662 14.2106C4.26708 11.2125 3.65605 8.17722 3.08206 5.21639C2.98948 4.76947 2.91541 4.34118 2.82283 3.89426C2.76728 3.65218 3.02651 3.46596 3.2487 3.57769C3.7116 3.81977 4.19302 4.08048 4.65592 4.32256C7.15558 5.64469 9.74782 7.00406 12.266 8.36344C12.4326 8.45655 12.7289 8.66138 12.7659 8.92209C12.7844 9.12692 12.6548 9.40625 12.3586 9.64833C11.7661 10.1884 11.1365 10.6911 10.4885 11.2312C10.4329 11.2684 10.3774 11.3056 10.3403 11.3615C10.1737 11.3429 10.0811 11.3243 9.91446 11.3056C9.47008 10.6911 9.06273 10.0952 8.58131 9.5366C8.32209 9.22003 7.95177 9.08968 7.65551 8.97795C7.56293 8.92209 7.47035 8.88484 7.39629 8.8476Z'
      fill='#F2F2F2'
    />
  </svg>
);
const SellToRetailerSvg = () => (
  <svg
    width='100%'
    height='100%'
    viewBox='0 0 20 23'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 22.4348H0V0H20V22.4348ZM18 20.5652V1.86957H2V20.5652H18ZM13.3333 16.2029V17.9478H15.2V16.2029H13.3333ZM11.4667 16.2029H4V17.9478H11.4667V16.2029ZM7.9208 11.5162C7.35092 11.5162 7.08783 11.3069 7.08783 10.8857V8.33552H7.96616V7.07639H7.08783V6.5165C7.08783 5.39325 6.35096 4.67392 5.04103 4.67392C4.8579 4.67392 4.77071 4.67608 4.64881 4.68716L4.34773 4.71452V5.92128H4.85385C5.45768 5.92128 5.61483 6.06758 5.61483 6.54005V7.07639H4.33333V8.33552H5.61483V10.8857C5.61483 12.0551 6.50501 12.7754 7.9208 12.7754C10.1691 12.7754 11.6667 11.0835 11.6667 8.98962C11.6667 7.7685 10.726 6.93506 9.34629 6.93506H8.9976L9.01329 7.26068C9.0189 7.37697 9.03418 7.6348 9.03317 7.61613C9.03778 7.70147 9.0403 7.77689 9.04178 7.88654L9.04593 8.1942H9.37509C9.94169 8.1942 10.1937 8.45775 10.1937 8.98962C10.1937 10.4353 9.25771 11.5162 7.9208 11.5162Z'
      fill='#C37300'
    />
  </svg>
);
const PendingIconSvg = () => (
  <svg
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      cx='5'
      cy='5'
      r='5'
      fill='#FF5238'
    />
  </svg>
);
const VerifiedIconSvg = () => (
  <svg
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      cx='5'
      cy='5'
      r='5'
      fill='#37CFAB'
    />
  </svg>
);
const HamburgerIconSvg = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4 6C4 5.73478 4.10536 5.48043 4.29289 5.29289C4.48043 5.10536 4.73478 5 5 5H19C19.2652 5 19.5196 5.10536 19.7071 5.29289C19.8946 5.48043 20 5.73478 20 6C20 6.26522 19.8946 6.51957 19.7071 6.70711C19.5196 6.89464 19.2652 7 19 7H5C4.73478 7 4.48043 6.89464 4.29289 6.70711C4.10536 6.51957 4 6.26522 4 6Z'
      fill='#FFEAE9'
    />
    <path
      d='M4 18C4 17.7348 4.10536 17.4804 4.29289 17.2929C4.48043 17.1054 4.73478 17 5 17H19C19.2652 17 19.5196 17.1054 19.7071 17.2929C19.8946 17.4804 20 17.7348 20 18C20 18.2652 19.8946 18.5196 19.7071 18.7071C19.5196 18.8946 19.2652 19 19 19H5C4.73478 19 4.48043 18.8946 4.29289 18.7071C4.10536 18.5196 4 18.2652 4 18Z'
      fill='#FFEAE9'
    />
    <path
      d='M5 11C4.73478 11 4.48043 11.1054 4.29289 11.2929C4.10536 11.4804 4 11.7348 4 12C4 12.2652 4.10536 12.5196 4.29289 12.7071C4.48043 12.8946 4.73478 13 5 13H13C13.2652 13 13.5196 12.8946 13.7071 12.7071C13.8946 12.5196 14 12.2652 14 12C14 11.7348 13.8946 11.4804 13.7071 11.2929C13.5196 11.1054 13.2652 11 13 11H5Z'
      fill='#FFEAE9'
    />
  </svg>
);

const BuildingIconSvg = () => (
  /*<svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.16667 10.4167H7.29167V13.5417H4.16667V10.4167ZM9.375 13.5417H12.5V10.4167H9.375V13.5417ZM4.16667 18.75H7.29167V15.625H4.16667V18.75ZM9.375 18.75H12.5V15.625H9.375V18.75ZM4.16667 8.33333H7.29167V5.20833H4.16667V8.33333ZM9.375 8.33333H12.5V5.20833H9.375V8.33333ZM25 8.85417V25H0V3.64583C0 2.6789 0.384113 1.75157 1.06784 1.06784C1.75157 0.384113 2.6789 0 3.64583 0L13.0208 0C13.9878 0 14.9151 0.384113 15.5988 1.06784C16.2826 1.75157 16.6667 2.6789 16.6667 3.64583V5.20833H21.3542C22.3211 5.20833 23.2484 5.59245 23.9322 6.27617C24.6159 6.9599 25 7.88723 25 8.85417ZM13.5417 3.64583C13.5417 3.5077 13.4868 3.37522 13.3891 3.27755C13.2914 3.17987 13.159 3.125 13.0208 3.125H3.64583C3.5077 3.125 3.37522 3.17987 3.27755 3.27755C3.17987 3.37522 3.125 3.5077 3.125 3.64583V21.875H13.5417V3.64583ZM21.875 8.85417C21.875 8.71603 21.8201 8.58356 21.7225 8.48588C21.6248 8.38821 21.4923 8.33333 21.3542 8.33333H16.6667V21.875H21.875V8.85417ZM17.7083 13.5417H20.8333V10.4167H17.7083V13.5417ZM17.7083 18.75H20.8333V15.625H17.7083V18.75Z"
      fill="#FA9D1C"
    />
  </svg>*/
  <img
    src={'/icons/company.jpeg'}
    width={28}
    height={28}
  />
);
const KeySvg = () => (
  <svg
    width='26'
    height='26'
    viewBox='0 0 26 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M23.2915 1.20271e-05H19.71C19.2121 -0.00124629 18.7188 0.0962442 18.2587 0.286844C17.7987 0.477444 17.381 0.75737 17.0299 1.11043L9.43785 8.70243C8.38963 8.60629 7.33267 8.70435 6.32002 8.99168C4.86403 9.40084 3.54046 10.1839 2.48084 11.263C1.42121 12.3421 0.662425 13.6798 0.279877 15.143C-0.102671 16.6062 -0.0956604 18.144 0.300212 19.6037C0.696084 21.0633 1.46704 22.394 2.53645 23.4634C3.60587 24.5328 4.93653 25.3038 6.39618 25.6997C7.85584 26.0955 9.39368 26.1025 10.8569 25.72C12.3201 25.3374 13.6577 24.5787 14.7368 23.519C15.816 22.4594 16.599 21.1358 17.0082 19.6798C17.3016 18.6487 17.3986 17.5716 17.2942 16.5046L18.4165 15.2447V13H21.6665V9.75001H23.7899L24.8894 8.97001C25.2425 8.61885 25.5224 8.20116 25.713 7.74112C25.9036 7.28108 26.0011 6.78781 25.9999 6.28985V2.70835C25.9999 2.35268 25.9298 2.0005 25.7937 1.67191C25.6576 1.34332 25.4581 1.04476 25.2066 0.793265C24.9551 0.541773 24.6565 0.342278 24.328 0.206172C23.9994 0.0700651 23.6472 1.20271e-05 23.2915 1.20271e-05ZM22.7499 6.28985C22.7496 6.36209 22.7348 6.43355 22.7065 6.50001H18.4165V9.75001H15.1665V14.0053L13.7354 15.4776C13.9603 16.0707 14.078 16.6991 14.0832 17.3333C14.0832 18.4047 13.7655 19.4519 13.1703 20.3427C12.5751 21.2335 11.7292 21.9277 10.7394 22.3377C9.74962 22.7477 8.66051 22.8549 7.60978 22.6459C6.55905 22.4369 5.59389 21.921 4.83636 21.1635C4.07882 20.406 3.56293 19.4408 3.35393 18.3901C3.14493 17.3394 3.2522 16.2502 3.66217 15.2605C4.07215 14.2707 4.76641 13.4247 5.65718 12.8296C6.54795 12.2344 7.5952 11.9167 8.66652 11.9167C9.28734 11.9225 9.90244 12.0361 10.4844 12.2525L19.3276 3.40818C19.4291 3.30692 19.5666 3.25004 19.71 3.25001H22.7499V6.28985ZM5.41652 18.9583C5.41652 19.2797 5.51182 19.5939 5.69038 19.8612C5.86894 20.1284 6.12273 20.3367 6.41966 20.4597C6.71659 20.5826 7.04332 20.6148 7.35854 20.5521C7.67376 20.4894 7.96331 20.3347 8.19057 20.1074C8.41783 19.8801 8.57259 19.5906 8.63529 19.2754C8.698 18.9601 8.66582 18.6334 8.54282 18.3365C8.41983 18.0396 8.21155 17.7858 7.94432 17.6072C7.67709 17.4287 7.36291 17.3333 7.04152 17.3333C6.61054 17.3333 6.19722 17.5046 5.89247 17.8093C5.58772 18.114 5.41652 18.5274 5.41652 18.9583Z'
      fill='#FA9D1C'
    />
  </svg>
);
const ArrowWoTailSvg = () => (
  <svg
    width='6'
    height='8'
    viewBox='0 0 6 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.726562 7.06L3.7799 4L0.726562 0.94L1.66656 0L5.66656 4L1.66656 8L0.726562 7.06Z'
      fill='#1D1D1D'
    />
  </svg>
);
const SupportSvg = () => (
  <svg
    width='27'
    height='27'
    viewBox='0 0 27 27'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.5157 26.6243C12.8211 26.6252 12.1504 26.3705 11.6314 25.9088L7.58363 22.5H0V3.9375C0 2.89321 0.414843 1.89169 1.15327 1.15327C1.89169 0.414843 2.89321 0 3.9375 0L23.0625 0C24.1068 0 25.1083 0.414843 25.8467 1.15327C26.5852 1.89169 27 2.89321 27 3.9375V22.5H19.494L15.3225 25.9481C14.8241 26.3883 14.1807 26.6291 13.5157 26.6243ZM3.375 19.125H8.8155L13.5 23.0749L18.279 19.125H23.625V3.9375C23.625 3.78832 23.5657 3.64524 23.4602 3.53975C23.3548 3.43426 23.2117 3.375 23.0625 3.375H3.9375C3.78832 3.375 3.64524 3.43426 3.53975 3.53975C3.43426 3.64524 3.375 3.78832 3.375 3.9375V19.125ZM13.5 11.25C14.0563 11.25 14.6 11.0851 15.0625 10.776C15.5251 10.467 15.8855 10.0277 16.0984 9.5138C16.3113 8.99988 16.367 8.43438 16.2585 7.88881C16.1499 7.34324 15.8821 6.8421 15.4887 6.44876C15.0954 6.05543 14.5943 5.78756 14.0487 5.67904C13.5031 5.57052 12.9376 5.62622 12.4237 5.83909C11.9098 6.05196 11.4705 6.41245 11.1615 6.87496C10.8525 7.33747 10.6875 7.88124 10.6875 8.4375C10.6875 9.18342 10.9838 9.89879 11.5113 10.4262C12.0387 10.9537 12.7541 11.25 13.5 11.25ZM9 14.625V16.875H18V14.625C18 14.0283 17.7629 13.456 17.341 13.034C16.919 12.6121 16.3467 12.375 15.75 12.375H11.25C10.6533 12.375 10.081 12.6121 9.65901 13.034C9.23705 13.456 9 14.0283 9 14.625Z'
      fill='#FA9D1C'
    />
  </svg>
);
const SettingsSvg = () => (
  <svg
    width='27'
    height='27'
    viewBox='0 0 27 27'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.1248 27H16.8748V23.0479C18.0479 22.6328 19.1344 22.0051 20.0799 21.1961L23.5044 23.175L26.8794 17.325L23.456 15.3506C23.6809 14.1271 23.6809 12.8729 23.456 11.6494L26.8794 9.675L23.5044 3.825L20.0799 5.80387C19.1344 4.99492 18.0479 4.36718 16.8748 3.95212V0H10.1248V3.95212C8.95168 4.36718 7.86515 4.99492 6.91964 5.80387L3.49514 3.825L0.120142 9.675L3.54352 11.6494C3.31864 12.8729 3.31864 14.1271 3.54352 15.3506L0.120142 17.325L3.49514 23.175L6.91964 21.1972C7.86524 22.0058 8.95177 22.6332 10.1248 23.0479V27ZM14.6248 24.75H12.3748V21.3446L11.5299 21.1264C10.1439 20.7673 8.88232 20.0364 7.88152 19.0125L7.27064 18.3904L4.31977 20.0947L3.19477 18.1462L6.14227 16.4441L5.91052 15.6049C5.52954 14.2244 5.52954 12.7666 5.91052 11.3861L6.14227 10.5469L3.19477 8.84475L4.31977 6.89625L7.27064 8.60512L7.88152 7.9875C8.88287 6.96526 10.1444 6.2359 11.5299 5.87812L12.3748 5.65537V2.25H14.6248V5.65537L15.4696 5.87362C16.8557 6.23267 18.1172 6.96362 19.118 7.9875L19.7289 8.60962L22.6798 6.90075L23.8048 8.84925L20.8573 10.5514L21.089 11.3906C21.47 12.7711 21.47 14.2289 21.089 15.6094L20.8573 16.4486L23.8048 18.1507L22.6798 20.0992L19.7289 18.3949L19.118 19.017C18.1167 20.0392 16.8552 20.7686 15.4696 21.1264L14.6248 21.3446V24.75ZM13.4998 18C14.3898 18 15.2598 17.7361 15.9998 17.2416C16.7399 16.7471 17.3166 16.0443 17.6572 15.2221C17.9978 14.3998 18.0869 13.495 17.9133 12.6221C17.7397 11.7492 17.3111 10.9474 16.6817 10.318C16.0524 9.68868 15.2506 9.2601 14.3777 9.08646C13.5048 8.91283 12.6 9.00195 11.7777 9.34254C10.9554 9.68314 10.2526 10.2599 9.75816 10.9999C9.26369 11.74 8.99977 12.61 8.99977 13.5C8.99977 14.6935 9.47387 15.8381 10.3178 16.682C11.1617 17.5259 12.3063 18 13.4998 18ZM13.4998 11.25C13.9448 11.25 14.3798 11.382 14.7498 11.6292C15.1198 11.8764 15.4082 12.2278 15.5785 12.639C15.7488 13.0501 15.7934 13.5025 15.7065 13.939C15.6197 14.3754 15.4054 14.7763 15.0908 15.091C14.7761 15.4057 14.3752 15.6199 13.9387 15.7068C13.5023 15.7936 13.0499 15.749 12.6387 15.5787C12.2276 15.4084 11.8762 15.12 11.629 14.75C11.3817 14.38 11.2498 13.945 11.2498 13.5C11.2498 12.9033 11.4868 12.331 11.9088 11.909C12.3307 11.4871 12.903 11.25 13.4998 11.25Z'
      fill='#FA9D1C'
    />
  </svg>
);
const LogoutSvg = () => (
  <svg
    width='25'
    height='25'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_1142_33154)'>
      <path
        d='M19.2642 8.23254L15.1392 4.10754L13.3717 5.87504L16.25 8.75004H5.51416V11.25H16.25L13.375 14.125L15.1425 15.8925L19.2675 11.7675C19.7357 11.2983 19.9984 10.6623 19.9978 9.99936C19.9972 9.33644 19.7333 8.70092 19.2642 8.23254Z'
        fill='#FCFDFF'
      />
      <path
        d='M8.32822 17.0834C8.32822 17.1939 8.28432 17.2999 8.20618 17.378C8.12804 17.4562 8.02206 17.5 7.91155 17.5H2.92155C2.81104 17.5 2.70506 17.4562 2.62692 17.378C2.54878 17.2999 2.50488 17.1939 2.50488 17.0834V2.94255C2.50488 2.83204 2.54878 2.72606 2.62692 2.64792C2.70506 2.56978 2.81104 2.52588 2.92155 2.52588H7.91155C8.02206 2.52588 8.12804 2.56978 8.20618 2.64792C8.28432 2.72606 8.32822 2.83204 8.32822 2.94255V6.95421H10.8282V2.94255C10.8271 2.16934 10.5195 1.42811 9.97273 0.881368C9.42598 0.334626 8.68476 0.0269811 7.91155 0.0258789H2.92155C2.14834 0.0269811 1.40711 0.334626 0.860372 0.881368C0.31363 1.42811 0.00598504 2.16934 0.00488281 2.94255V17.0834C0.00488281 17.8569 0.312174 18.5988 0.859155 19.1458C1.40614 19.6928 2.148 20 2.92155 20H7.91155C8.6851 20 9.42696 19.6928 9.97394 19.1458C10.5209 18.5988 10.8282 17.8569 10.8282 17.0834V13.0692H8.32822V17.0834Z'
        fill='#FCFDFF'
      />
    </g>
    <defs>
      <clipPath id='clip0_1142_33154'>
        <rect
          width='20'
          height='20'
          fill='white'
        />
      </clipPath>
    </defs>
  </svg>
);
const HumbeeWhiteLogoSvg = () => (
  <svg
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    width='70%'
    viewBox='0 0 861 291'
    enable-background='new 0 0 861 291'
  >
    <path
      fill='#00000000'
      opacity='1.000000'
      stroke='none'
      d='
M654.000000,292.000000 
	C436.000000,292.000000 218.500000,292.000000 1.000000,292.000000 
	C1.000000,195.000000 1.000000,98.000000 1.000000,1.000000 
	C288.000000,1.000000 575.000000,1.000000 862.000000,1.000000 
	C862.000000,98.000000 862.000000,195.000000 862.000000,292.000000 
	C792.833313,292.000000 723.666687,292.000000 654.000000,292.000000 
M191.236633,93.525848 
	C189.914612,89.882599 188.592606,86.239357 187.219040,81.887108 
	C184.191910,73.626221 178.005096,68.169502 170.716171,63.912666 
	C152.766586,53.429848 134.782394,43.001369 116.666298,32.810219 
	C103.121216,25.190475 89.341019,25.513258 75.889122,33.148129 
	C58.534901,42.997829 41.326077,53.103397 24.030111,63.056152 
	C9.341400,71.508591 1.890688,84.075600 1.958469,101.111885 
	C2.037322,120.931328 1.978676,140.751328 1.976225,160.571091 
	C1.974197,176.959549 9.095875,189.321182 23.175852,197.587631 
	C39.382187,207.102478 55.711388,216.407959 71.923965,225.912277 
	C80.856476,231.148788 90.213913,234.615036 100.950943,234.632339 
	C105.010864,243.217834 111.724693,249.102249 119.862572,253.713104 
	C135.723907,262.699982 151.692429,271.526062 167.225128,281.056671 
	C183.036880,290.758514 198.508484,291.288605 214.506180,281.893646 
	C231.512436,271.906403 248.659378,262.158997 265.712677,252.251373 
	C273.241028,247.877548 278.936676,241.748993 283.630005,233.899506 
	C291.791626,234.213516 299.552917,232.527069 306.629944,228.509232 
	C323.840118,218.738495 340.950195,208.791077 358.078278,198.876236 
	C373.437225,189.985489 381.649872,177.200241 381.196716,158.880264 
	C380.702606,138.905594 381.169464,118.908760 381.055450,98.922508 
	C380.969666,83.882187 374.189972,72.198532 361.538971,64.521347 
	C343.770142,53.738438 325.604034,43.606743 307.545135,33.306381 
	C293.152466,25.097130 278.771606,25.514271 264.499207,33.769566 
	C247.081314,43.844227 229.559738,53.743267 212.255081,64.008347 
	C204.896378,68.373528 198.512085,73.947212 195.223114,83.066330 
	C194.109131,86.667824 192.995132,90.269318 191.236633,93.525848 
M825.107849,45.637032 
	C814.312805,67.269348 803.517761,88.901657 792.394897,111.190834 
	C791.244568,109.064278 790.513672,107.784119 789.847534,106.471107 
	C777.796143,82.718033 765.779541,58.947189 753.646973,35.235695 
	C752.830322,33.639751 751.197998,31.365479 749.863831,31.308525 
	C741.435913,30.948734 732.984985,31.126064 724.428284,31.126064 
	C724.428284,70.438805 724.428284,109.125130 724.428284,147.717682 
	C730.460083,147.717682 736.033325,147.717682 742.200928,147.717682 
	C742.200928,122.552292 742.200928,97.787498 742.200928,73.022713 
	C755.141296,96.635818 767.446472,120.252541 779.315430,144.086472 
	C781.421570,148.315704 784.299805,147.967697 787.782104,148.190048 
	C791.400818,148.421127 793.422180,147.248413 795.096008,143.842392 
	C805.963989,121.727890 817.083069,99.736748 828.130432,77.710472 
	C828.796326,76.382843 829.551697,75.100075 830.265381,73.796425 
	C830.589050,73.928955 830.912720,74.061485 831.236389,74.194016 
	C831.236389,98.635849 831.236389,123.077690 831.236389,147.766754 
	C840.641113,147.766754 849.682373,147.766754 859.098633,147.766754 
	C859.098633,108.814018 859.098633,70.222420 859.098633,31.106451 
	C854.973999,31.106451 851.233887,31.679165 847.735474,31.002367 
	C835.770386,28.687666 828.542358,33.398617 825.107849,45.637032 
M538.420776,180.993515 
	C528.945374,174.767578 518.325745,172.266159 507.203979,172.091141 
	C491.049774,171.836945 474.888611,172.015533 458.730469,172.038574 
	C457.298340,172.040619 455.866516,172.256287 454.371338,172.377884 
	C454.371338,211.366348 454.371338,249.922363 454.371338,288.713684 
	C455.972046,288.823364 457.266510,288.988495 458.561127,288.989288 
	C477.385284,289.000793 496.209717,289.053375 515.033447,288.959015 
	C524.748962,288.910339 533.770020,286.059998 541.948975,280.938477 
	C560.576111,269.274567 560.732483,244.855255 542.327271,232.884384 
	C539.476685,231.030350 536.383057,229.550125 533.512573,227.958420 
	C537.444885,224.612335 541.551819,221.894302 544.665649,218.312881 
	C552.046692,209.823456 553.809998,192.133713 538.420776,180.993515 
M482.972839,119.500000 
	C482.972839,110.745010 482.972839,101.990021 482.972839,93.237801 
	C499.026520,93.237801 514.254700,93.237801 530.132690,93.237801 
	C530.132690,111.640236 530.132690,129.685577 530.132690,147.783554 
	C539.699463,147.783554 548.607361,147.783554 557.668701,147.783554 
	C557.668701,108.794792 557.668701,70.147804 557.668701,31.447689 
	C548.301086,31.447689 539.398682,31.447689 529.854675,31.447689 
	C529.854675,48.665134 529.854675,65.540413 529.854675,82.514633 
	C513.973328,82.514633 498.742676,82.514633 482.861023,82.514633 
	C482.861023,65.307556 482.861023,48.432102 482.861023,31.105310 
	C474.752289,31.105310 467.277863,31.366976 459.833099,31.009811 
	C455.166443,30.785923 453.942169,32.381851 453.964508,36.948666 
	C454.137177,72.252800 454.052094,107.558167 454.064758,142.863159 
	C454.065338,144.465820 454.237183,146.068420 454.333466,147.744629 
	C464.041809,147.744629 473.261047,147.744629 482.972809,147.744629 
	C482.972809,138.415970 482.972809,129.457977 482.972839,119.500000 
M588.968384,31.353619 
	C588.616150,32.898563 587.961304,34.442677 587.957031,35.988567 
	C587.892334,59.649853 587.775818,83.312424 587.958435,106.972481 
	C588.091248,124.179482 595.870605,137.295273 611.422180,144.565048 
	C632.417480,154.379532 653.805908,153.572128 674.388245,143.124390 
	C685.761963,137.350983 693.179077,127.242813 693.720215,114.568855 
	C694.855957,87.969093 694.607239,61.308716 694.731812,34.672295 
	C694.737305,33.494026 692.887878,31.373978 691.775574,31.285431 
	C687.009094,30.905993 682.195068,31.123657 677.001709,31.123657 
	C676.833862,34.206001 676.577637,36.817753 676.567444,39.430470 
	C676.487854,59.813755 676.638794,80.200249 676.302795,100.578903 
	C676.194702,107.138504 675.774414,113.967461 673.848816,120.160767 
	C670.649231,130.451889 662.897949,137.012360 652.270264,138.745361 
	C640.960449,140.589615 630.880798,137.718079 623.362610,128.138733 
	C617.553711,120.737350 616.240662,112.126122 616.176697,103.242546 
	C616.018372,81.251015 616.151184,59.257446 616.141541,37.264709 
	C616.140686,35.345238 615.952393,33.425854 615.832458,31.150398 
	C606.809021,31.150398 598.341187,31.150398 588.968384,31.353619 
M771.141968,277.053375 
	C752.227600,277.053375 733.313232,277.053375 714.393799,277.053375 
	C714.393799,261.258881 714.393799,246.345627 714.393799,230.872208 
	C716.526428,230.872208 718.315430,230.872208 720.104492,230.872208 
	C732.270569,230.872192 744.436707,230.877350 756.602783,230.870071 
	C763.085876,230.866196 763.111938,230.849640 762.954529,224.597748 
	C762.926636,223.488815 762.659851,222.385895 762.424927,220.725494 
	C746.307800,220.725494 730.399231,220.725494 714.422852,220.725494 
	C714.422852,207.569229 714.422852,195.014526 714.422852,181.874878 
	C734.027954,181.874878 753.263855,181.874878 772.629517,181.874878 
	C772.629517,178.373581 772.629517,175.469147 772.629517,172.360748 
	C743.416687,172.360748 714.532654,172.360748 685.441162,172.360748 
	C685.441162,211.281525 685.441162,249.849686 685.441162,288.673309 
	C714.640686,288.673309 743.526367,288.673309 773.289551,288.673309 
	C772.842834,284.608765 772.440002,280.942932 771.141968,277.053375 
M647.499634,172.010788 
	C625.086304,172.010788 602.673035,172.010788 580.292358,172.010788 
	C580.292358,211.426987 580.292358,249.988586 580.292358,288.556274 
	C609.372620,288.556274 638.072144,288.556274 666.653320,288.556274 
	C666.653320,284.531525 666.653320,280.956482 666.653320,276.797241 
	C647.029358,276.797241 627.803955,276.797241 608.488647,276.797241 
	C608.488647,261.287842 608.488647,246.378235 608.488647,230.844086 
	C624.706726,230.844086 640.604553,230.844086 656.602661,230.844086 
	C656.602661,227.191986 656.602661,224.177017 656.602661,220.858734 
	C654.298706,220.858734 652.476929,220.858871 650.655212,220.858688 
	C638.325500,220.857468 625.991577,220.672745 613.668213,220.951263 
	C609.159119,221.053192 607.886475,219.494583 608.073486,215.188644 
	C608.376953,208.203705 608.155334,201.195938 608.155273,194.197815 
	C608.155273,190.268433 608.155212,186.339050 608.155212,181.843567 
	C628.169373,181.843567 647.407593,181.843567 666.712585,181.843567 
	C666.712585,178.350586 666.712585,175.443817 666.712585,172.023315 
	C660.415771,172.023315 654.457520,172.023315 647.499634,172.010788 
M157.328674,30.163404 
	C166.973984,35.723923 176.728714,41.106373 186.210648,46.932777 
	C189.993408,49.257187 193.110580,49.277607 196.825974,47.104153 
	C215.469193,36.198097 234.185867,25.417593 252.874496,14.589124 
	C257.783051,11.745028 258.917023,8.808986 256.606537,4.981041 
	C254.521286,1.526342 251.111908,0.995610 246.665237,3.550842 
	C230.817398,12.657654 214.810379,21.507156 199.240219,31.067438 
	C193.291840,34.719822 188.743607,33.894424 183.263504,30.607494 
	C167.733368,21.292589 152.001221,12.313387 136.311676,3.266039 
	C132.302994,0.954433 128.618988,1.673322 126.644722,4.876414 
	C124.623734,8.155302 125.973358,12.121549 129.901260,14.393310 
	C138.819412,19.551256 147.742340,24.700994 157.328674,30.163404 
z'
    />
    <path
      fill='#B1B3B5'
      opacity='1.000000'
      stroke='none'
      d='
M100.761368,233.919220 
	C90.213913,234.615036 80.856476,231.148788 71.923965,225.912277 
	C55.711388,216.407959 39.382187,207.102478 23.175852,197.587631 
	C9.095875,189.321182 1.974197,176.959549 1.976225,160.571091 
	C1.978676,140.751328 2.037322,120.931328 1.958469,101.111885 
	C1.890688,84.075600 9.341400,71.508591 24.030111,63.056152 
	C41.326077,53.103397 58.534901,42.997829 75.889122,33.148129 
	C89.341019,25.513258 103.121216,25.190475 116.666298,32.810219 
	C134.782394,43.001369 152.766586,53.429848 170.716171,63.912666 
	C178.005096,68.169502 184.191910,73.626221 186.834167,82.391319 
	C181.149567,84.694618 175.433670,85.746597 170.624191,88.425735 
	C152.504364,98.519424 134.588226,108.989632 116.774963,119.619080 
	C103.963814,127.263680 97.318146,138.962708 97.100662,153.802429 
	C96.788353,175.112335 96.748360,196.436447 97.220955,217.740524 
	C97.340439,223.127029 99.844353,228.460617 101.134033,233.864502 
	C101.015503,233.910461 100.761368,233.919220 100.761368,233.919220 
z'
    />
    <path
      fill='#B1B3B5'
      opacity='1.000000'
      stroke='none'
      d='
M195.822388,82.605591 
	C198.512085,73.947212 204.896378,68.373528 212.255081,64.008347 
	C229.559738,53.743267 247.081314,43.844227 264.499207,33.769566 
	C278.771606,25.514271 293.152466,25.097130 307.545135,33.306381 
	C325.604034,43.606743 343.770142,53.738438 361.538971,64.521347 
	C374.189972,72.198532 380.969666,83.882187 381.055450,98.922508 
	C381.169464,118.908760 380.702606,138.905594 381.196716,158.880264 
	C381.649872,177.200241 373.437225,189.985489 358.078278,198.876236 
	C340.950195,208.791077 323.840118,218.738495 306.629944,228.509232 
	C299.552917,232.527069 291.791626,234.213516 283.062256,233.709198 
	C282.494476,233.518906 282.419739,233.123093 282.660400,232.776382 
	C283.934998,227.291153 285.780945,222.165298 285.861206,217.011917 
	C286.195648,195.545456 286.221191,174.067581 285.917694,152.600128 
	C285.717957,138.472626 279.091278,127.420517 267.139130,120.106506 
	C252.876755,111.378807 238.192703,103.342911 223.765152,94.881447 
	C214.916489,89.691864 206.337479,83.968208 195.822388,82.605591 
z'
    />
    <path
      fill='#F59B1F'
      opacity='1.000000'
      stroke='none'
      d='
M282.419739,233.123093 
	C282.419739,233.123093 282.494476,233.518906 282.596863,233.692108 
	C278.936676,241.748993 273.241028,247.877548 265.712677,252.251373 
	C248.659378,262.158997 231.512436,271.906403 214.506180,281.893646 
	C198.508484,291.288605 183.036880,290.758514 167.225128,281.056671 
	C151.692429,271.526062 135.723907,262.699982 119.862572,253.713104 
	C111.724693,249.102249 105.010864,243.217834 100.856155,234.275787 
	C100.761368,233.919220 101.015503,233.910461 101.507126,233.863007 
	C109.943245,232.873978 116.724068,229.180756 123.284401,224.907974 
	C126.469002,222.833832 129.733643,220.874619 133.029221,218.980225 
	C146.662674,211.143433 160.641678,203.849579 173.857422,195.365112 
	C182.468826,189.836609 188.821152,181.871124 190.081772,170.938782 
	C190.237640,169.587082 191.311279,168.341202 192.001129,167.435791 
	C194.388596,180.808472 201.097641,190.726273 212.595581,197.374588 
	C228.520554,206.582672 244.362030,215.935623 260.314819,225.094955 
	C267.187805,229.041092 273.934540,233.530457 282.419739,233.123093 
z'
    />
    <path
      fill='#C37429'
      opacity='1.000000'
      stroke='none'
      d='
M191.959610,167.046280 
	C191.311279,168.341202 190.237640,169.587082 190.081772,170.938782 
	C188.821152,181.871124 182.468826,189.836609 173.857422,195.365112 
	C160.641678,203.849579 146.662674,211.143433 133.029221,218.980225 
	C129.733643,220.874619 126.469002,222.833832 123.284401,224.907974 
	C116.724068,229.180756 109.943245,232.873978 101.625656,233.817032 
	C99.844353,228.460617 97.340439,223.127029 97.220955,217.740524 
	C96.748360,196.436447 96.788353,175.112335 97.100662,153.802429 
	C97.318146,138.962708 103.963814,127.263680 116.774963,119.619080 
	C134.588226,108.989632 152.504364,98.519424 170.624191,88.425735 
	C175.433670,85.746597 181.149567,84.694618 186.859924,82.745819 
	C188.592606,86.239357 189.914612,89.882599 191.596039,94.136307 
	C191.956833,118.846611 191.958221,142.946442 191.959610,167.046280 
z'
    />
    <path
      fill='#955222'
      opacity='1.000000'
      stroke='none'
      d='
M192.001129,167.435791 
	C191.958221,142.946442 191.956833,118.846611 191.918289,94.308792 
	C192.995132,90.269318 194.109131,86.667824 195.522751,82.835960 
	C206.337479,83.968208 214.916489,89.691864 223.765152,94.881447 
	C238.192703,103.342911 252.876755,111.378807 267.139130,120.106506 
	C279.091278,127.420517 285.717957,138.472626 285.917694,152.600128 
	C286.221191,174.067581 286.195648,195.545456 285.861206,217.011917 
	C285.780945,222.165298 283.934998,227.291153 282.660400,232.776382 
	C273.934540,233.530457 267.187805,229.041092 260.314819,225.094955 
	C244.362030,215.935623 228.520554,206.582672 212.595581,197.374588 
	C201.097641,190.726273 194.388596,180.808472 192.001129,167.435791 
z'
    />
    <path
      fill='#B2B4B6'
      opacity='1.000000'
      stroke='none'
      d='
M825.282837,45.307358 
	C828.542358,33.398617 835.770386,28.687666 847.735474,31.002367 
	C851.233887,31.679165 854.973999,31.106451 859.098633,31.106451 
	C859.098633,70.222420 859.098633,108.814018 859.098633,147.766754 
	C849.682373,147.766754 840.641113,147.766754 831.236389,147.766754 
	C831.236389,123.077690 831.236389,98.635849 831.236389,74.194016 
	C830.912720,74.061485 830.589050,73.928955 830.265381,73.796425 
	C829.551697,75.100075 828.796326,76.382843 828.130432,77.710472 
	C817.083069,99.736748 805.963989,121.727890 795.096008,143.842392 
	C793.422180,147.248413 791.400818,148.421127 787.782104,148.190048 
	C784.299805,147.967697 781.421570,148.315704 779.315430,144.086472 
	C767.446472,120.252541 755.141296,96.635818 742.200928,73.022713 
	C742.200928,97.787498 742.200928,122.552292 742.200928,147.717682 
	C736.033325,147.717682 730.460083,147.717682 724.428284,147.717682 
	C724.428284,109.125130 724.428284,70.438805 724.428284,31.126064 
	C732.984985,31.126064 741.435913,30.948734 749.863831,31.308525 
	C751.197998,31.365479 752.830322,33.639751 753.646973,35.235695 
	C765.779541,58.947189 777.796143,82.718033 789.847534,106.471107 
	C790.513672,107.784119 791.244568,109.064278 792.394897,111.190834 
	C803.517761,88.901657 814.312805,67.269348 825.282837,45.307358 
z'
    />
    <path
      fill='#B2B4B6'
      opacity='1.000000'
      stroke='none'
      d='
M538.705933,181.219482 
	C553.809998,192.133713 552.046692,209.823456 544.665649,218.312881 
	C541.551819,221.894302 537.444885,224.612335 533.512573,227.958420 
	C536.383057,229.550125 539.476685,231.030350 542.327271,232.884384 
	C560.732483,244.855255 560.576111,269.274567 541.948975,280.938477 
	C533.770020,286.059998 524.748962,288.910339 515.033447,288.959015 
	C496.209717,289.053375 477.385284,289.000793 458.561127,288.989288 
	C457.266510,288.988495 455.972046,288.823364 454.371338,288.713684 
	C454.371338,249.922363 454.371338,211.366348 454.371338,172.377884 
	C455.866516,172.256287 457.298340,172.040619 458.730469,172.038574 
	C474.888611,172.015533 491.049774,171.836945 507.203979,172.091141 
	C518.325745,172.266159 528.945374,174.767578 538.705933,181.219482 
M517.196045,272.887238 
	C524.112915,268.244629 526.748657,261.727112 525.653381,253.575653 
	C524.421082,244.404037 519.576843,237.834351 510.448334,236.096786 
	C501.637024,234.419647 492.555878,234.160202 483.398132,233.258759 
	C483.398132,248.692001 483.398132,262.684082 483.398132,276.979950 
	C494.833771,276.566528 506.090118,278.791321 517.196045,272.887238 
M513.772766,219.443771 
	C520.313721,214.192932 522.011719,207.212830 520.610474,199.339737 
	C519.205933,191.448563 514.029846,186.496735 506.535095,184.944977 
	C499.046539,183.394516 491.287201,183.151932 483.415039,182.311295 
	C483.415039,196.604355 483.415039,209.589264 483.415039,223.051926 
	C493.656769,222.049423 503.787323,225.114258 513.772766,219.443771 
z'
    />
    <path
      fill='#B2B4B6'
      opacity='1.000000'
      stroke='none'
      d='
M482.972839,120.000000 
	C482.972809,129.457977 482.972809,138.415970 482.972809,147.744629 
	C473.261047,147.744629 464.041809,147.744629 454.333466,147.744629 
	C454.237183,146.068420 454.065338,144.465820 454.064758,142.863159 
	C454.052094,107.558167 454.137177,72.252800 453.964508,36.948666 
	C453.942169,32.381851 455.166443,30.785923 459.833099,31.009811 
	C467.277863,31.366976 474.752289,31.105310 482.861023,31.105310 
	C482.861023,48.432102 482.861023,65.307556 482.861023,82.514633 
	C498.742676,82.514633 513.973328,82.514633 529.854675,82.514633 
	C529.854675,65.540413 529.854675,48.665134 529.854675,31.447689 
	C539.398682,31.447689 548.301086,31.447689 557.668701,31.447689 
	C557.668701,70.147804 557.668701,108.794792 557.668701,147.783554 
	C548.607361,147.783554 539.699463,147.783554 530.132690,147.783554 
	C530.132690,129.685577 530.132690,111.640236 530.132690,93.237801 
	C514.254700,93.237801 499.026520,93.237801 482.972839,93.237801 
	C482.972839,101.990021 482.972839,110.745010 482.972839,120.000000 
z'
    />
    <path
      fill='#B2B4B6'
      opacity='1.000000'
      stroke='none'
      d='
M589.420898,31.252008 
	C598.341187,31.150398 606.809021,31.150398 615.832458,31.150398 
	C615.952393,33.425854 616.140686,35.345238 616.141541,37.264709 
	C616.151184,59.257446 616.018372,81.251015 616.176697,103.242546 
	C616.240662,112.126122 617.553711,120.737350 623.362610,128.138733 
	C630.880798,137.718079 640.960449,140.589615 652.270264,138.745361 
	C662.897949,137.012360 670.649231,130.451889 673.848816,120.160767 
	C675.774414,113.967461 676.194702,107.138504 676.302795,100.578903 
	C676.638794,80.200249 676.487854,59.813755 676.567444,39.430470 
	C676.577637,36.817753 676.833862,34.206001 677.001709,31.123657 
	C682.195068,31.123657 687.009094,30.905993 691.775574,31.285431 
	C692.887878,31.373978 694.737305,33.494026 694.731812,34.672295 
	C694.607239,61.308716 694.855957,87.969093 693.720215,114.568855 
	C693.179077,127.242813 685.761963,137.350983 674.388245,143.124390 
	C653.805908,153.572128 632.417480,154.379532 611.422180,144.565048 
	C595.870605,137.295273 588.091248,124.179482 587.958435,106.972481 
	C587.775818,83.312424 587.892334,59.649853 587.957031,35.988567 
	C587.961304,34.442677 588.616150,32.898563 589.420898,31.252008 
z'
    />
    <path
      fill='#B2B4B6'
      opacity='1.000000'
      stroke='none'
      d='
M771.589539,277.165222 
	C772.440002,280.942932 772.842834,284.608765 773.289551,288.673309 
	C743.526367,288.673309 714.640686,288.673309 685.441162,288.673309 
	C685.441162,249.849686 685.441162,211.281525 685.441162,172.360748 
	C714.532654,172.360748 743.416687,172.360748 772.629517,172.360748 
	C772.629517,175.469147 772.629517,178.373581 772.629517,181.874878 
	C753.263855,181.874878 734.027954,181.874878 714.422852,181.874878 
	C714.422852,195.014526 714.422852,207.569229 714.422852,220.725494 
	C730.399231,220.725494 746.307800,220.725494 762.424927,220.725494 
	C762.659851,222.385895 762.926636,223.488815 762.954529,224.597748 
	C763.111938,230.849640 763.085876,230.866196 756.602783,230.870071 
	C744.436707,230.877350 732.270569,230.872192 720.104492,230.872208 
	C718.315430,230.872208 716.526428,230.872208 714.393799,230.872208 
	C714.393799,246.345627 714.393799,261.258881 714.393799,277.053375 
	C733.313232,277.053375 752.227600,277.053375 771.589539,277.165222 
z'
    />
    <path
      fill='#B1B3B5'
      opacity='1.000000'
      stroke='none'
      d='
M647.999512,172.017059 
	C654.457520,172.023315 660.415771,172.023315 666.712585,172.023315 
	C666.712585,175.443817 666.712585,178.350586 666.712585,181.843567 
	C647.407593,181.843567 628.169373,181.843567 608.155212,181.843567 
	C608.155212,186.339050 608.155273,190.268433 608.155273,194.197815 
	C608.155334,201.195938 608.376953,208.203705 608.073486,215.188644 
	C607.886475,219.494583 609.159119,221.053192 613.668213,220.951263 
	C625.991577,220.672745 638.325500,220.857468 650.655212,220.858688 
	C652.476929,220.858871 654.298706,220.858734 656.602661,220.858734 
	C656.602661,224.177017 656.602661,227.191986 656.602661,230.844086 
	C640.604553,230.844086 624.706726,230.844086 608.488647,230.844086 
	C608.488647,246.378235 608.488647,261.287842 608.488647,276.797241 
	C627.803955,276.797241 647.029358,276.797241 666.653320,276.797241 
	C666.653320,280.956482 666.653320,284.531525 666.653320,288.556274 
	C638.072144,288.556274 609.372620,288.556274 580.292358,288.556274 
	C580.292358,249.988586 580.292358,211.426987 580.292358,172.010788 
	C602.673035,172.010788 625.086304,172.010788 647.999512,172.017059 
z'
    />
    <path
      fill='#B2B4B6'
      opacity='1.000000'
      stroke='none'
      d='
M156.996002,30.008738 
	C147.742340,24.700994 138.819412,19.551256 129.901260,14.393310 
	C125.973358,12.121549 124.623734,8.155302 126.644722,4.876414 
	C128.618988,1.673322 132.302994,0.954433 136.311676,3.266039 
	C152.001221,12.313387 167.733368,21.292589 183.263504,30.607494 
	C188.743607,33.894424 193.291840,34.719822 199.240219,31.067438 
	C214.810379,21.507156 230.817398,12.657654 246.665237,3.550842 
	C251.111908,0.995610 254.521286,1.526342 256.606537,4.981041 
	C258.917023,8.808986 257.783051,11.745028 252.874496,14.589124 
	C234.185867,25.417593 215.469193,36.198097 196.825974,47.104153 
	C193.110580,49.277607 189.993408,49.257187 186.210648,46.932777 
	C176.728714,41.106373 166.973984,35.723923 156.996002,30.008738 
z'
    />
    <path
      fill='#00000000'
      opacity='1.000000'
      stroke='none'
      d='
M516.856567,273.043701 
	C506.090118,278.791321 494.833771,276.566528 483.398132,276.979950 
	C483.398132,262.684082 483.398132,248.692001 483.398132,233.258759 
	C492.555878,234.160202 501.637024,234.419647 510.448334,236.096786 
	C519.576843,237.834351 524.421082,244.404037 525.653381,253.575653 
	C526.748657,261.727112 524.112915,268.244629 516.856567,273.043701 
z'
    />
    <path
      fill='#00000000'
      opacity='1.000000'
      stroke='none'
      d='
M513.458252,219.645432 
	C503.787323,225.114258 493.656769,222.049423 483.415039,223.051926 
	C483.415039,209.589264 483.415039,196.604355 483.415039,182.311295 
	C491.287201,183.151932 499.046539,183.394516 506.535095,184.944977 
	C514.029846,186.496735 519.205933,191.448563 520.610474,199.339737 
	C522.011719,207.212830 520.313721,214.192932 513.458252,219.645432 
z'
    />
  </svg>
);

const CompanyDetaialsSvg = () => (
  <svg
    version='1.0'
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='25'
    viewBox='0 0 20 20'
    preserveAspectRatio='xMidYMid meet'
  >
    <g
      transform='translate(0.000000,1024.000000) scale(0.100000,-0.100000)'
      fill='#000000'
      stroke='none'
    ></g>
  </svg>
);

export const CompanyDetaialsIcon = () => (
  <Icon component={CompanyDetaialsSvg} />
);

export const VerifiedIcon = (props) => (
  <Icon
    component={VerifiedIconSvg}
    {...props}
  />
);
export const HamburgerIcon = (props) => (
  <Icon
    component={HamburgerIconSvg}
    {...props}
  />
);

export const PendingIcon = (props) => (
  <Icon
    component={PendingIconSvg}
    {...props}
  />
);
export const HeartIcon = (props) => (
  <Icon
    component={HeartSvg}
    {...props}
  />
);

export const PandaIcon = (props) => (
  <Icon
    component={PandaSvg}
    {...props}
  />
);

export const LockIcon = (props) => (
  <Icon
    component={LockSvg}
    {...props}
  />
);
export const LoginBgImage = (props) => (
  <Icon
    component={LoginImg}
    {...props}
  />
);
export const SellToMasonIcon = (props) => (
  <Icon
    component={SellToMasonSvg}
    {...props}
  />
);
export const SellToRetailerIcon = (props) => (
  <Icon
    component={SellToRetailerSvg}
    {...props}
  />
);
export const BuildingIcon = () => <Icon component={BuildingIconSvg} />;

export const KeyIcon = () => (
  //    <Icon component={KeySvg} />
  <img
    src={'/icons/password.jpeg'}
    width={28}
    height={28}
  />
);
export const ArrowWoTail = () => <Icon component={ArrowWoTailSvg} />;
export const SupportIcon = () => (
  // <Icon component={SupportSvg} />
  <img
    src={'/icons/support.jpeg'}
    width={28}
    height={28}
  />
);
export const LangIcon = () => (
  <img
    src={'/icons/lang.jpeg'}
    width={28}
    height={28}
  />
);
export const SettingsIcon = () => <Icon component={SettingsSvg} />;
export const LogoutIcon = () => <Icon component={LogoutSvg} />;
export const HumbeeLogo = () => <Icon component={HumbeeWhiteLogoSvg} />;
/*
ReactDOM.render(
    <Space>
        <HeartIcon style={{ color: 'hotpink' }} />
        <PandaIcon style={{ fontSize: '32px' }} />
        <Icon component={HomeOutlined} />
        <HomeOutlined />
    </Space>,
    mountNode,
);*/
